/*
 * @Author: yindengli
 * @Date: 2023-06-26 11:04:28
 * @LastEditTime: 2023-11-01 13:52:57
 * @LastEditors: yindengli
 * @Description: 
 * @FilePath: \openseeyon-index-front\src\utils\request.js
 */
import {
  Modal
} from 'ant-design-vue';
import axios from 'axios';
import { getCookie } from "@/utils/common";
import eventBus from '@/utils/eventBus'

const service = axios.create({
  baseURL: '/', // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 60000 // request timeout
})

service.interceptors.request.use(
  request => {
    request.headers.Authorization = sessionStorage.getItem('token');
    request.headers['token'] = getCookie("loginKey");
    return request
  },
  error => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    if(response.data.code != 200 && response.data.code != 0) {
      Modal.destroyAll();
      let message = response.data.msg || response.data.message || '服务器异常！';
      switch (response.data.code) {
        case 500:
          Modal.error({title: '系统内部错误，请联系管理员查看'})
          break;
        case 504:
          Modal.error({title: '操作频繁，请稍后再试！'})
          break;
        case 10026:
          // 登录失效
          eventBus.$emit("logionExpired")
          Modal.error({
            title: message,
            okText: '去登录',
            onOk:()=>{
              window.location.href = `${process.env.VUE_APP_cloudUrl}/c/login?back_url=`+encodeURIComponent(window.location.href) + '&type=open';
            }
          })
          break;
        default:
          Modal.error({title: message})
          break;
      }
    }
    return response.data
  },
  error => {
    Modal.destroyAll();
    var errorMsg = error.message;
    if(errorMsg.indexOf('500') > -1) {
      // 如果不能连接到服务器
      Modal.error({
        title: "服务器连接失败！"
      });
    }else if(errorMsg.indexOf('404') > -1) {
      // 找不到该请求
      Modal.error({
        title: "存在未知请求，请检查请求路径！"
      });
    }else {
      Modal.error({
        title: errorMsg
      });
    }
    return Promise.reject(error)
  }
)

export default service